export * from '@primeuix/themes/nora/timeline';
export { default } from '@primeuix/themes/nora/timeline';
